import shadowsDecisions, { shadowsOptions } from '@classify/design-tokens/shadows';

const shadows = {
  0: 'none',
  ...shadowsOptions,
  ...shadowsDecisions,
};

export default shadows;
